import request from './request'

export function getAddressList() {
  return request.get('/Address/list')
}

export function getAddressDetail(id) {
  return request.get('/Address/info', { params: { id } })
}

export function addAddress(data) {
  return request.post('/Address/add', data)
}

export function editAddress(data) {
  return request.post('/Address/edit', data)
}

export function deleteAddress(id) {
  return request.post('/Address/delete', { id })
}

export function setDefaultAddress(id) {
  return request.post('/Address/setDefault', { id })
}
